import React, { useEffect, useState } from "react";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/payroll/column";
import { GetPayrollClientApi } from "../../api/request/payroll/payroll";
import { useNavigate } from "react-router-dom";
import { ReactComponent as User } from "../../assets/User.svg";
import GlobalTooltip from "../../components/common/GlobalTooltip";
import moment from "moment";
import ViewPayroll from "../../assets/ViewPayroll";


const Payroll = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState()

    const getPayrollClients = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetPayrollClientApi();

            setData(
                data?.data?.map((item) => {
                    return {
                        ...item,
                        status: <p className={`${item?.status == 'active' ? 'text-green-500' : 'text-red-500'} capitalize font-bold`}>{item?.status}</p>,
                        created_at: moment(item?.created_at).format("lll"),
                        action: (
                            <div className="flex gap-3">
                                <GlobalTooltip title="View Employees">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/payroll/${item?.id}`,{
                                                state: { client: item },
                                            })
                                        }
                                        }
                                    >
                                        <User className="size-5" />
                                    </button>
                                </GlobalTooltip>
                                <GlobalTooltip title="View Payrolls">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/payroll/view_payroll/${item?.id}`, {
                                                state: { client: item },
                                            });
                                        }}

                                    >
                                        <ViewPayroll />
                                    </button>
                                </GlobalTooltip>
                            </div>
                        ),
                    };
                }) || []
            );
        } catch (error) {
            console.error("Error fetching payroll clients:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getPayrollClients();
    }, []);

    return (
        <div className="border rounded-xl bg-white">
            {/* <div className="flex justify-between mx-5 mt-5">
                <p className="title">Client Payrolls</p>
            </div> */}
            <div className="flex justify-between mx-5 mt-5">
                <p className="title">
                    Payroll Clients  {data?.length ? `(${data?.length})` : ""}
                </p>
                <div className="flex gap-3 items-center">


                </div>
            </div>

            <div className="mt-5">
                <SkeletonTable
                    columns={columns}
                    data={data}
                    isLoading={isLoading}
                    pagination={true}
                    // onRowClick={(record)=> navigate(`/payroll/view_payroll/${record?.id}`)}
                    onRowClick={(record) =>
                        navigate(`/payroll/view_payroll/${record?.id}`, {
                            state: {
                                client: {
                                    email: record?.email,
                                    name: record?.name,
                                },
                            },
                        })
                    }


                />
            </div>
        </div>
    );
};

export default Payroll;
